//* --------------------------------------------------*\
//    $SELECTORS - CSS selectors ONLY
// -  tag names, #ids, .classnames, [attributes], etc
//* --------------------------------------------------*/

const SELECTORS = {
  ACCORDION: '.accordion',
  ACCORDION_BUTTON: '.accordion__button',
  ACCORDION_PANEL: '.accordion__panel',
  ALL: '#all',
  ANCHOR: 'a',
  ANCHOR_WITH_HREF: 'a[href]',
  BUTTON: 'button',
  CHECKED: ':checked',
  CHECKED_LABEL: ':checked + label',
  CHECKBOX: 'checkbox',
  CLOSE: '.close',
  DATA_BOTTOM: 'data-bottomposition',
  DATA_HALFWAY: 'data-halfway',
  DATA_HAS_ANIMATED: 'data-has-animated',
  DATA_LAZY_LOAD: 'data-lazyload',
  DATA_MOUSEFOLLOW: '[data-mousefollow]',
  DATA_POSITION: 'data-position',
  DATA_VISIBLE: '[data-visible]',
  DATEPICKER: '.datepicker',
  DIV: 'div',
  DROPDOWN_BUTTON: '.dropdown-trigger',
  EVENTSLANDING_BOTTOM: '.eventslanding__bottom',
  HEADER: 'header',
  HEADER_CONTROL: '.menu-open',
  HEADER_CONTROL_LABEL: '.menu-open-label',
  HIGHPRIORITY_LOADER_API: '.highpriority__loader--api',
  HIGHPRIORITY_LOADER_PINNED: '.highpriority__loader--pinned',
  INPUT_GROUP: '.input-group',
  INPUT_GROUP_FIRST_NAME: '.input-group--first-name',
  INPUT_GROUP_LAST_NAME: '.input-group--last-name',
  INPUT_GROUP_EMAIL: '.input-group--email',
  INPUT_GROUP_PHONE: '.input-group--phone',
  INPUT_GROUP_ZIP: '.input-group--zip',
  FORM_ACTIONNETWORK: '.form__actionnetwork',
  FORM_CLOSEBUTTON: '.signupform__closebutton',
  FORM_FORM: '.form__form',
  FORM_INPUT_LAST_NAME: '.form__form-input--last-name',
  FORM_INPUT_FIRST_NAME: '.form__form-input--first-name',
  FORM_INPUT_EMAIL: '.form__form-input--email',
  FORM_INPUT_PHONE: '.form__form-input--phone',
  FORM_INPUT_ZIP: '.form__form-input--zip',
  FORM_POST_SUBMIT: '.form__post-submit',
  MAIN: 'main',
  MODAL_CLOSE_BUTTON: '.modal__closebutton',
  MOBILIZE_EVENT_PINNED: '.mobilizeevent--pinned',
  NAV_MENU: '#menu-header-menu-mobile',
  RADIO: '[type="radio"]',
  RESOURCE: '.resourcessection__resource',
  SPAN: 'span',
  SOURCE_LINKS:
    '.highpriority__noresultstext a[href],a.mobilizeevent__link[href], a.otherevents__link[href], a.resourcessection__resourcelink[href], a.alertbar__link[href], a.priorityevents__link[href],.callspage a[href],a.surgebar__link[href]',
  STICKY_HEADER_DARK: '.sticky-header-dark',
  VIDEO_EMBED: '.ta-ytvideo__embed',
  VIDEO_PICTURE: '.ta-ytvideo__picture',
  VIDEO_TRIGGER: '.ta-ytvideo__poster'
};

export default SELECTORS;
